import BreadcrumbWithLink from "components/Common/BreadcrumbWithLink";
import ConfirmModal from "components/shared-components/ConfirmModal";
import { actionAccess } from "constants/actionAccess";
import {
  ORDER_TYPE,
  SHIPPING_TYPE,
  STATUS,
  TIME_SLOT_TYPE,
} from "constants/order";
import { CheckActionAccess } from "helpers/utils";
import {
  useCancelOrder,
  useCancelOrderReasonList,
  useChangeOrderCustomer,
  useChangeOrderSale,
  useChangeOrderStatus,
  useCheckRole,
  useDetailBus,
  useDetailCustomer,
  useDetailOrder,
  useDetailOrderAttachments,
  useDetailOrderHistory,
  useDetailOrderReminders,
  useDetailRunnerUser,
  useDetailTransport,
  useDistricts,
  useForwardOrder,
  useListRunnerUser,
  useListShippingUnitAll,
  useOrderStatus,
  useProvinces,
  useRefundOrder,
  useResourceType,
  useRunnerByRule,
  useTimeSlots,
  useWards,
} from "hooks";
import {
  useDeleteReminder,
  useDeleteResource,
  useDownloadMultipleResources,
  useResourceGlobalPreview,
} from "hooks/resource-global/useResourceGlobal";
import CreateOrderGetGoodsModal from "pages/ManageOrders/CreateOrderGetGoodsModal/CreateOrderGetGoodsModal";
import {
  checkErrorForHandleOrdersCoordinate,
  getLableOrderStatus,
  orderStatusMode,
} from "pages/Orders/utils";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { MetaTags } from "react-meta-tags";
import { Link, useParams } from "react-router-dom";
import {
  Alert,
  Button,
  Card,
  Container,
  Modal,
  ModalBody,
  ModalHeader,
} from "reactstrap";
import ChangeCustomerForm from "../ChangeCustomerForm/ChangeCustomerForm";
import ChangeOrderStatusForm from "../ChangeOrderStatusForm/ChangeOrderStatusForm";
import ChangeSaleForm from "../ChangeSaleForm/ChangeSaleForm";
import OrderCoordinationForm from "../OrderCoordination/OrderCoordinationForm/OrderCoordinationForm";
import OrderDetailAttachments from "../OrderDetailAttachments/OrderDetailAttachments";
import OrderDetailChild from "../OrderDetailChild/OrderDetailChild";
import OrderDetailForm from "../OrderDetailForm/OrderDetailForm";
import OrderDetailHistory from "../OrderDetailHistory/OrderDetailHistory";
import OrderDetailReminder from "../OrderDetailReminder/OrderDetailReminder";
import "./OrderDetailPage.scss";
import UpdateRefCodeForm from "./UpdateRefCodeForm";
import WarningNote from "./WarningNote";

const initRunnerByRuleParams = {
  hub_id: null,
  action_date: "",
  time_slot: 0,
  province_code: "",
  district_code: "",
  ward_code: "",
  run: false,
};

const initRunnerDetailParams = {
  runnerId: "",
  run: false,
};
const initTransportParams = {
  transportId: "",
};
const initBusParams = {
  busId: "",
};
const initCustomerParams = () => {
  return {
    customerId: "",
  };
};

const initLocalitiesParams = () => {
  return {
    countryId: 1,
    type: 1,
    parent_code: "",
  };
};

const OrderDetailPage = props => {
  const { t } = useTranslation(["order"]);

  const ref = useRef(null);

  const [userType, setUserType] = useState(null);
  const [resourceId, setResourceId] = useState(null);
  const [order, setOrder] = useState(null);
  const [runnerParams, setRunnerParams] = useState(initRunnerDetailParams);
  const [runnerByRuleParams, setRunnerByRuleParams] = useState(
    initRunnerByRuleParams
  );
  const [openForwardOrderPopup, setOpenForwardOrderPopup] = useState(false);
  const [openChangeOrderStatusPopup, setOpenChangeOrderStatusPopup] =
    useState(false);
  const [openCancelOrderPopup, setOpenCancelOrderPopup] = useState(false);

  const [openChangeCustomerPopup, setOpenChangeCustomerPopup] = useState(false);
  const toggleChangeCustomerPopup = () => {
    setOpenChangeCustomerPopup(!openChangeCustomerPopup);
  };
  const [openChangeSalePopup, setOpenChangeSalePopup] = useState(false);
  const toggleChangeSalePopup = () => {
    setOpenChangeSalePopup(!openChangeSalePopup);
  };

  const [isOpenRefundOrder, setIsOpenRefundOrder] = useState(false);
  /** @param {boolean} [data] */
  const toggleOpenRefundOrder = data => {
    setIsOpenRefundOrder(prev => (data !== undefined ? data : !prev));
  };

  const pageParams = useParams();
  const orderId = useMemo(() => {
    return pageParams?.orderDetailId || null;
  }, [pageParams]);

  const [isHCMOrder, setIsHCMOrder] = useState(false);
  const [shipping, setShipping] = useState();
  const [transportParam, setTransportParam] = useState(initTransportParams);
  const [busParam, setBusParam] = useState(initBusParams);
  const [customerParams, setCustomerParams] = useState(initCustomerParams);
  const [provinceParams, setProvinceParams] = useState(initLocalitiesParams);
  const [districtParams, setDistrictParams] = useState(initLocalitiesParams);
  const [wardParams, setWardParams] = useState(initLocalitiesParams);
  const [deleteModal, setDeleteModal] = useState(false);
  const [idDeleteRemind, setIdDeleteRemind] = useState(null);
  const [shouldRenderChildrenOrders, setShouldRenderChildrenOrders] =
    useState(false);
  const [shouldRenderParentButton, setShouldRenderParentButton] =
    useState(false);

  const [hubId, setHubId] = useState(undefined);
  const [timeSlotsParams, setTimeSlotsParams] = useState({
    params: {
      "filter[type][in]": [TIME_SLOT_TYPE.COORDINATE, TIME_SLOT_TYPE.RUNNER],
      "filter[hub_id]": undefined,
    },
    key: "time-slot-orders-detail",
    enabled: false,
    run: false,
  });
  const { isLogAdmin } = useCheckRole();

  // Detail Order
  const onSuccessDetailOrder = data => {
    setOrder(data);
    setOrderRefCode(data.ref_code);
    setShouldRenderParentButton(String(data?.type) !== "1");
    // Order for bus pickup
    const isOrderGetGoods =
      Number(data?.type) === ORDER_TYPE.RECEIVE.value && data?.is_receive_bus
        ? true
        : false;
    //
    setShouldRenderChildrenOrders(data?.childs?.length > 0 || isOrderGetGoods);
  };

  const { refetch: refetchDetailOrder } = useDetailOrder(
    {
      orderId: orderId,
    },
    onSuccessDetailOrder
  );

  // time slot
  const { data: dataTimeSlots, refetch: refetchTimeSlots } = useTimeSlots(
    timeSlotsParams,
    () => {
      onFetchReason();
      fetchListRunner();
    }
  );

  useEffect(() => {
    refetchTimeSlots();
  }, [timeSlotsParams]);

  useEffect(() => {
    if (order) {
      let { hub_id } = checkErrorForHandleOrdersCoordinate({
        selectedRows: [order],
      });
      setHubId(hub_id);
      setTimeSlotsParams(prev => {
        return {
          ...prev,
          params: {
            ...prev.params,
            "filter[hub_id]": hub_id,
          },
          run: true,
        };
      });
    }
  }, [order]);

  // order status list
  const fetchOrderStatusListSuccess = () => {
    refetchDetailOrder();
  };

  const { refetch: refetchOrderStatus, data: dataOrderStatusList } =
    useOrderStatus(fetchOrderStatusListSuccess);

  // order detail history
  const {
    refetch: refetchOrderHistory,
    data: dataHistory,
    isLoading: isHistoryLoading,
  } = useDetailOrderHistory({
    orderId: orderId,
  });

  // order detail attachments
  const {
    refetch: refetchOrderAttachments,
    data: dataAttachments,
    isLoading: isAttachmentsLoading,
  } = useDetailOrderAttachments({
    orderId: orderId,
  });

  const {
    refetch: refetchOrderReminders,
    data: dataOrderReminders,
    isLoading: isOrderReminderLoading,
  } = useDetailOrderReminders({
    orderId: orderId,
  });

  // Refund Order
  const { mutate: mutateRefundOrder, isLoading: isLoadingRefundOrder } =
    useRefundOrder({
      onSuccess: () => {
        toggleOpenRefundOrder(false);
        setTimeout(() => {
          window.location.reload();
        }, 1500);
      },
      onError: () => {},
    });

  // Constants for checking order status
  const invalidStatuses = [
    orderStatusMode.MAKE,
    orderStatusMode.COMPLETED,
    orderStatusMode.WAITING,
  ];

  // Fetching reason cancel order list
  const { refetch: onFetchReason, data: reasonListData } =
    useCancelOrderReasonList(1);

  /** Fetch all order related details */
  const fetchOrderDetails = () => {
    refetchOrderHistory();
    refetchOrderAttachments();
    refetchOrderReminders();
  };

  // Success handlers for transport information
  const handleTransportSuccess = {
    onSuccessTransportDetail: data => setShipping(data),
    onSuccessBusDetail: data => setShipping(data),
  };

  // Success handlers for orders
  const onSuccessForwardOrder = () => {
    refetchDetailOrder();
    fetchOrderDetails();
  };

  const onSuccessChangeOrderStatus = () => {
    refetchDetailOrder();
    fetchOrderDetails();
  };

  const onSuccessChangeOrderCustomer = () => {
    refetchDetailOrder();
    fetchOrderDetails();
    toggleChangeCustomerPopup();
  };

  const onSuccessChangeOrderSale = () => {
    refetchDetailOrder();
    fetchOrderDetails();
    toggleChangeSalePopup();
  };

  const onSuccessCancelOrder = () => {
    refetchDetailOrder();
    fetchOrderDetails();
    ref?.current?.clearChildrenList();
  };

  // Forward order
  const { mutate: mutateForwardOrder } = useForwardOrder(onSuccessForwardOrder);

  // Change order status
  const { mutate: mutateChangeOrderStatus } = useChangeOrderStatus(
    onSuccessChangeOrderStatus
  );

  // Change Order Customer
  const {
    mutate: mutateChangeCustomer,
    isLoading: isLoadingChangeOrderCustomer,
  } = useChangeOrderCustomer(onSuccessChangeOrderCustomer);

  // Change Order Sale
  const { mutate: mutateChangeSale, isLoading: isLoadingChangeOrderSale } =
    useChangeOrderSale(onSuccessChangeOrderSale);

  // Cancel order
  const { mutate: mutateCancelOrder } = useCancelOrder(onSuccessCancelOrder);

  /** @returns {boolean} */
  const isAllowOrderRefund = useMemo(() => {
    // Do not allow refund for bus pickup orders
    if (order?.is_receive_bus) {
      return false;
    }

    if (
      order?.status &&
      Array.isArray(dataOrderStatusList) &&
      dataOrderStatusList?.length > 1
    ) {
      const hasInvalidStatus = invalidStatuses.some(x => x === order.status);
      return !hasInvalidStatus;
    }

    return false;
  }, [order, dataOrderStatusList]);

  useEffect(() => {
    setResourceId(resourceId);
  }, [orderId]);

  //get resource type
  const { data: dataResourceType } = useResourceType();

  // resource global preview
  const {
    data: dataResourceData,
    isLoading: isLoadingResource,
    refetch: fetchResourceGlobalPreview,
  } = useResourceGlobalPreview({
    resourceId: resourceId,
  });

  // download multiple resources
  const onSuccessDownloadMultipleResources = data => {
    if (!!data) {
      var url = window.URL || window.webkitURL;
      const urlData = url.createObjectURL(
        new Blob([data], { type: "application/zip" })
      );
      const link = document.createElement("a");
      link.href = urlData;
      link.target = "_blank";
      link.setAttribute("download", "Attachments.zip");
      document.body.append(link);
      link.click();
      document.body.removeChild(link);
      url.revokeObjectURL(urlData);
    }
  };

  const onErrorDownloadMultipleResources = () => {};

  const {
    mutate: mutateDownloadResources,
    isLoading: isDownloadingMultipleResources,
  } = useDownloadMultipleResources(
    onSuccessDownloadMultipleResources,
    onErrorDownloadMultipleResources
  );

  // delete resource
  const onDeleteResourceSuccess = () => {
    refetchOrderAttachments();
  };

  const { mutate: mutateDeleteResource, isLoading: isDeletingResource } =
    useDeleteResource(onDeleteResourceSuccess, () => {});

  // delete reminder
  const onDeleteReminderSuccess = () => {
    refetchOrderReminders();
    toggleDeleteModal();
  };

  const { mutate: mutateDeleteReminder, isLoading: isDeletingReminder } =
    useDeleteReminder(onDeleteReminderSuccess, () => {});

  const toggleDeleteModal = () => {
    setDeleteModal(!deleteModal);
  };

  const isAddressLevel2 = useMemo(() => {
    return order?.is_new_address === "N";
  }, [order?.is_new_address]);

  const { data: dataProvinces, refetch: refetchProvinces } = useProvinces({
    ...provinceParams,
    record_status: isAddressLevel2 ? "O" : "C",
  });

  const { data: dataDistricts, refetch: refetchDistricts } = useDistricts({
    ...districtParams,
    record_status: isAddressLevel2 ? "O" : "C",
  });

  const { data: dataWards, refetch: refetchWards } = useWards({
    ...wardParams,
    record_status: isAddressLevel2 ? "O" : "C",
  });

  // runner
  const fetchRunnerListSuccess = () => {
    refetchOrderStatus();
  };

  const { data: dataRunners, refetch: fetchListRunner } = useListRunnerUser(
    fetchRunnerListSuccess
  );

  // runner by rule
  const { data: dataRunnerByRule, refetch: refetchRunnerByRule } =
    useRunnerByRule(runnerByRuleParams);

  useEffect(() => {
    if (runnerByRuleParams && runnerByRuleParams.run) {
      refetchRunnerByRule();
    }
  }, [runnerByRuleParams]);

  // get runner by id
  const { data: dataRunner, refetch: refetchRunnerDetail } =
    useDetailRunnerUser(runnerParams);

  useEffect(() => {
    if (runnerParams && runnerParams.run) refetchRunnerDetail();
  }, [runnerParams]);

  // forward order
  const handleForwardOrder = data => {
    const forwardOrderParams = { ...data };
    forwardOrderParams.order_id = order?.id;
    forwardOrderParams.transport_id = order?.orderDelivery?.transport_id;
    forwardOrderParams.bus_id = order?.orderDelivery?.bus_id;
    mutateForwardOrder(forwardOrderParams);
  };

  const handleChangeOrderStatus = data => {
    const orderParams = { ...data };
    orderParams.order_id = order?.id;
    mutateChangeOrderStatus(orderParams);
  };

  const handleChangeOrderCustomer = data => {
    mutateChangeCustomer({ orderId: order?.id, data });
  };

  const handleChangeOrderSale = data => {
    mutateChangeSale({ orderId: order?.id, data });
  };

  // get shipping type all
  const { data: dataShippingTypeAll, refetch: refetchShippingTypes } =
    useListShippingUnitAll();

  useEffect(() => {
    refetchShippingTypes();
  }, []);

  useEffect(() => {
    setUserType(localStorage.getItem("user_type"));
  }, []);

  useEffect(() => {
    if (resourceId) {
      fetchResourceGlobalPreview();
    }
  }, [resourceId]);

  useEffect(() => {
    if (orderId) {
      fetchOrderDetails();
    }
  }, [orderId]);

  useEffect(() => {
    setDistrictParams(prev => ({ ...prev, type: 2 }));
    setWardParams(prev => ({ ...prev, type: 3 }));
  }, []);

  useEffect(() => {
    if (provinceParams?.type === 1) refetchProvinces();
  }, [provinceParams, refetchProvinces, isAddressLevel2]);

  useEffect(() => {
    if (districtParams?.type === 2) refetchDistricts();
  }, [districtParams, refetchDistricts, isAddressLevel2]);

  useEffect(() => {
    if (wardParams?.type === 3) refetchWards();
  }, [wardParams, refetchWards, isAddressLevel2]);

  const getImagePreview = id => {
    setResourceId(id);
  };

  const downloadMultipleResources = ids => {
    mutateDownloadResources(ids);
  };

  const handleCancelOrder = value => {
    if (value.reasonId) {
      mutateCancelOrder({
        orderId: order.id,
        reason_note: value.note,
        reason_id: value.reasonId,
        order_code: order.order_code,
      });
      setOpenCancelOrderPopup(false);
    }
  };

  const hasCancel = order?.status === 1 || order?.status === 6;

  // Check user permissions
  const permissions = {
    cancel: CheckActionAccess(actionAccess.GLOG_FUNCTION_ORDER_CANCEL),
    forward: CheckActionAccess(actionAccess.GLOG_FUNCTION_ORDER_ASSIGN),
    changeStatus: CheckActionAccess(actionAccess.GLOG_FUNCTION_ORDER_ASSIGN),
    changeCustomer: CheckActionAccess(
      actionAccess.GLOG_FUNCTION_ORDER_CHANGE_CUSTOMER
    ),
  };

  // Check conditions for displaying status change button
  const checkChangeStatusConditions = () => {
    const { transport_id, status, is_receive_bus } = order || {};
    // Check if the order is a bus pickup order and the status is done or cancel
    if (
      is_receive_bus &&
      [STATUS.DONE, STATUS.CANCEL].includes(Number(status))
    ) {
      return false;
    }
    // Check basic conditions
    if (!transport_id && !status) return false;

    // Check transport and status conditions
    if ([1, 2].includes(Number(transport_id))) {
      if ([STATUS.COORDINATED, STATUS.RECEIVED].includes(Number(status))) {
        return false;
      }
    }

    return true;
  };

  // Check conditions for displaying customer change button
  const checkChangeCustomerConditions = () => {
    const { is_receive_bus, transport_id, status } = order || {};

    // Check bus receive condition
    if (is_receive_bus) return false;

    // Check basic conditions
    if (!transport_id && !status) return false;

    // Check transport and status conditions
    if ([1, 2].includes(Number(transport_id))) {
      if ([STATUS.COORDINATED, STATUS.RECEIVED].includes(Number(status))) {
        return false;
      }
    }

    return true;
  };

  // Check conditions for displaying coordination form
  const checkCoordinationConditions = () => {
    const { status, orderDelivery, is_receive_bus } = order || {};
    const shippingType = orderDelivery?.shipping_type;

    // Check conditions for RUNNER
    const isRunnerCondition =
      shippingType === SHIPPING_TYPE.RUNNER && status === STATUS.HUB_ARRIVED;

    // Check conditions for Đơn lấy hàng nhà xe
    const isOrderReceiveBusCondition =
      is_receive_bus &&
      [STATUS.NEW, STATUS.PENDING, STATUS.COORDINATED].includes(status);

    // Check conditions for NHAXE
    const isNhaXeCondition =
      shippingType === SHIPPING_TYPE.NHAXE &&
      [STATUS.HUB_ARRIVED, STATUS.NEW].includes(status);
    return true;
    return isRunnerCondition || isNhaXeCondition || isOrderReceiveBusCondition;
  };

  // Check conditions for child order sync
  const checkSyncChildConditions = () => {
    const { is_receive_bus, status } = order || {};
    const validStatus = [
      orderStatusMode.MAKE,
      orderStatusMode.WAITING,
      orderStatusMode.COORDINATED,
    ];

    return is_receive_bus === 1 && validStatus.includes(status);
  };

  // Transport hooks
  const transportHooks = {
    transport: useDetailTransport(
      transportParam,
      handleTransportSuccess.onSuccessTransportDetail
    ),
    bus: useDetailBus(busParam, handleTransportSuccess.onSuccessBusDetail),
  };

  useEffect(() => {
    if (transportParam?.transportId) transportHooks.transport.refetch();
  }, [transportParam]);

  useEffect(() => {
    if (busParam?.busId) transportHooks.bus.refetch();
  }, [busParam]);

  const { data: dataCustomer, refetch: refetchCustomer } =
    useDetailCustomer(customerParams);

  useEffect(() => {
    if (customerParams?.customerId) refetchCustomer();
  }, [customerParams, refetchCustomer]);

  // Results of condition checks
  const conditions = {
    isSyncChildOrder: checkSyncChildConditions(),
    canShowCancelButton:
      permissions.cancel && hasCancel && !order?.parent_id && isLogAdmin,
    canShowCoordinateButton:
      // checkCoordinationConditions() && !order?.parent_id && permissions.forward,
      checkCoordinationConditions() && permissions.forward,
    canShowChangeStatusButton:
      permissions.changeStatus &&
      !order?.parent_id &&
      checkChangeStatusConditions(),
    canShowChangeCustomerButton:
      permissions.changeCustomer && checkChangeCustomerConditions(),
    canShowChangeSaleButton:
      isLogAdmin &&
      order?.customer_id &&
      order?.is_reminder_order &&
      order?.status === STATUS.PENDING &&
      !order?.sale_id,
    canShowOrderNote:
      order &&
      order.shipping_type === SHIPPING_TYPE.NHAXE &&
      (order.status === STATUS.NEW || order.status === STATUS.PENDING),
    canShowCustomerNote: dataCustomer && dataCustomer.code === "GSNEW",
    canShowReminderAlert: Boolean(order?.is_reminder_order || 0),
    canShowMobileStatus: window.innerWidth <= 767 && order?.status,
  };

  const onSuccessInsertOrderRefCode = data => {
    setOrderRefCode(data.ref_code);
    setModalRefCodeOpen(false);
  };

  const [orderRefCode, setOrderRefCode] = useState("");

  const [modalRefCodeOpen, setModalRefCodeOpen] = useState(false);

  // START Sync child orders with parent
  const [
    dataDefaultCreateOrderGetGoodsPopup,
    setDataDefaultCreateOrderGetGoodsPopup,
  ] = useState({
    isCreateAfterOpen: false,
    order: null,
    bus_id: null,
    hub: null,
  });

  const [openCreateOrderGetGoodsPopup, setOpenCreateOrderGetGoodsPopup] =
    useState(false);

  const toggleOpenCreateOrderGetGoodsPopup = () => {
    setOpenCreateOrderGetGoodsPopup(!openCreateOrderGetGoodsPopup);
  };

  const syncOrderGetGoodsHandler = (row, indexCol, e) => {
    setDataDefaultCreateOrderGetGoodsPopup({
      isCreateAfterOpen: true,
      bus_id: row?.receive_bus_id,
      hub: {
        id: row?.from_hub,
        name: row?.from_hub_name,
      },
      order: row,
    });
    toggleOpenCreateOrderGetGoodsPopup();
  };

  // END Sync child orders with parent

  useEffect(() => {
    // Check if order is HCM order (Runner type)
    const hcmOrder =
      order?.shipping_type === SHIPPING_TYPE.RUNNER ? true : false;
    setIsHCMOrder(hcmOrder);

    // Set bus or transport parameters based on shipping type
    if (order?.orderDelivery?.shipping_type === SHIPPING_TYPE.NHAXE) {
      // Bus shipping type
      setBusParam({ busId: order?.orderDelivery?.bus_id });
    } else if (order?.orderDelivery?.shipping_type === SHIPPING_TYPE.RUNNER) {
      // Transport shipping type
      setTransportParam({ transportId: order?.orderDelivery?.transport_id });
    }

    setCustomerParams(prev => ({
      ...prev,
      customerId: order?.customer_id,
    }));
  }, [order]);

  return (
    <React.Fragment>
      <div className="page-content OrderDetailPage">
        <ConfirmModal
          isOpen={deleteModal}
          titleHeader={t("modal_reminder.delete.header")}
          titleBody={t("modal_reminder.delete.content")}
          onConfirm={() => {
            mutateDeleteReminder(idDeleteRemind);
          }}
          textBtnConfirm={t("modal_reminder.agree")}
          textBtnCancel={t("modal_reminder.cancel")}
          toggle={toggleDeleteModal}
        />
        <Container fluid={true}>
          <div className="d-md-flex justify-content-between">
            <div className="d-md-flex gap-3 align-items-center pb-0 OrderDetailPage__Title">
              <MetaTags>
                <title>{t("detail.title")}</title>
              </MetaTags>
              <BreadcrumbWithLink
                title={
                  <div className="d-flex align-items-center gap-2">
                    {t("detail.title")} {order?.order_code}
                    {order?.order_code && (
                      <Button
                        className="bg-light"
                        color=""
                        onClick={e => {
                          e.stopPropagation();
                          navigator.clipboard.writeText(order?.order_code);
                        }}
                      >
                        <i className="far fa-copy fa-md text-secondary" />
                      </Button>
                    )}
                  </div>
                }
              />
              <div className="mt-3 m-md-0 d-flex gap-md-3 gap-1 flex-wrap">
                {conditions.isSyncChildOrder ? (
                  <>
                    <CreateOrderGetGoodsModal
                      isHaveLinkOrderDetail={false}
                      dataDefaultCreateOrderGetGoodsPopup={
                        dataDefaultCreateOrderGetGoodsPopup
                      }
                      isLogAdmin={isLogAdmin}
                      createOrderSuccessHandle={() => {
                        refetchDetailOrder();
                        ref?.current?.refreshChildrenList();
                      }}
                      isOpen={openCreateOrderGetGoodsPopup}
                      toggle={toggleOpenCreateOrderGetGoodsPopup}
                    />
                    <Button
                      color="success"
                      className="d-flex gap-1 align-items-center"
                      onClick={() => syncOrderGetGoodsHandler(order)}
                    >
                      <i className="fas fa-sync fa-lg ms-2" />
                      Đồng bộ đơn con
                    </Button>
                  </>
                ) : (
                  <></>
                )}
                {conditions.canShowCoordinateButton ? (
                  <>
                    <Button
                      color="primary"
                      style={{ backgroundColor: "#3C64B1" }}
                      onClick={() =>
                        setOpenForwardOrderPopup(!openForwardOrderPopup)
                      }
                    >
                      {t("button.coordinate")}
                    </Button>
                    <Modal
                      isOpen={openForwardOrderPopup}
                      centered
                      toggle={() => {
                        setOpenForwardOrderPopup(!openForwardOrderPopup);
                      }}
                      scrollable
                      size="xl"
                    >
                      {openForwardOrderPopup && (
                        <OrderCoordinationForm
                          // data={{
                          //   action_date: order?.action_date,
                          //   timeslot_id: order?.timeslot_id,
                          // }}
                          // status={order?.status}
                          // shipping_type={order?.orderDelivery?.shipping_type}
                          defaultData={{
                            timeslot_id: order?.timeslot_id,
                            runner_id: order?.orderDelivery?.runner_id,
                            full_address:
                              order?.type === ORDER_TYPE.RECEIVE.value
                                ? order?.sender_address
                                : order?.reciever_address,
                            ward_code:
                              order?.type === ORDER_TYPE.RECEIVE.value
                                ? order?.sender_ward_code
                                : order?.reciever_ward_code,
                            district_code:
                              order?.type === ORDER_TYPE.RECEIVE.value
                                ? order?.sender_district_code
                                : order?.reciever_district_code,
                            province_code:
                              order?.type === ORDER_TYPE.RECEIVE.value
                                ? order?.sender_province_code
                                : order?.reciever_province_code,
                            contact_name:
                              order?.type === ORDER_TYPE.RECEIVE.value
                                ? order?.sender_contact_name
                                : order?.reciever_contact_name,
                            contact_phone:
                              order?.type === ORDER_TYPE.RECEIVE.value
                                ? order?.sender_contact_phone
                                : order?.reciever_contact_phone,
                            note: `${order?.mainNote || order?.note || ""}`,
                            is_new_address: order?.is_new_address,
                          }}
                          hubId={hubId}
                          timeSlots={dataTimeSlots?.items}
                          runners={dataRunners?.items}
                          handleCancel={() => {
                            setOpenForwardOrderPopup(false);
                          }}
                          // runnerByRule={runnerByRule}
                          // getRunner={refetchRunnerByRule}
                          onTimeSlotChange={timeslot_id => {
                            const params = { ...runnerByRuleParams };
                            params.time_slot = timeslot_id;
                            setRunnerByRuleParams(params);
                          }}
                          onActionDateChange={action_date => {
                            const params = { ...runnerByRuleParams };
                            params.action_date = action_date;
                            setRunnerByRuleParams(params);
                          }}
                          onForwardOrder={handleForwardOrder}
                        />
                      )}
                    </Modal>
                  </>
                ) : (
                  <></>
                )}
                {conditions.canShowChangeStatusButton ? (
                  <>
                    <Button
                      color="primary"
                      style={{ backgroundColor: "#3C64B1" }}
                      onClick={() =>
                        setOpenChangeOrderStatusPopup(
                          !openChangeOrderStatusPopup
                        )
                      }
                    >
                      {t("button.change_status")}
                    </Button>
                    <Modal
                      isOpen={openChangeOrderStatusPopup}
                      centered
                      toggle={() =>
                        setOpenChangeOrderStatusPopup(
                          !openChangeOrderStatusPopup
                        )
                      }
                    >
                      <ChangeOrderStatusForm
                        orderStatusList={dataOrderStatusList}
                        handleCancel={() =>
                          setOpenChangeOrderStatusPopup(false)
                        }
                        onSubmit={handleChangeOrderStatus}
                        isAnyNotAllowedGroupToTransfer={
                          !order?.allowed_group_to_transfer
                        }
                        placeHolderNotAllowedGroupToTransfer={
                          "Không thể chọn vì đối tượng là đơn nội thành"
                        }
                      />
                    </Modal>
                  </>
                ) : (
                  <></>
                )}
                {conditions.canShowChangeCustomerButton ? (
                  <React.Fragment>
                    <Button
                      color="primary"
                      style={{ backgroundColor: "#3C64B1" }}
                      onClick={toggleChangeCustomerPopup}
                    >
                      {t("button.change_customer")}
                    </Button>
                    <ChangeCustomerForm
                      isOpenModal={openChangeCustomerPopup}
                      toggleModal={toggleChangeCustomerPopup}
                      handleChangeOrderCustomer={handleChangeOrderCustomer}
                      isLoadingChangeOrderCustomer={
                        isLoadingChangeOrderCustomer
                      }
                    />
                  </React.Fragment>
                ) : (
                  <></>
                )}
                {conditions.canShowChangeSaleButton ? (
                  <React.Fragment>
                    <Button
                      color="primary"
                      style={{ backgroundColor: "#3C64B1" }}
                      onClick={toggleChangeSalePopup}
                    >
                      {t("button.change_sale")}
                    </Button>
                    <ChangeSaleForm
                      isOpenModal={openChangeSalePopup}
                      toggleModal={toggleChangeSalePopup}
                      handleChangeOrderSale={handleChangeOrderSale}
                      isLoadingChangeOrderSale={isLoadingChangeOrderSale}
                      customerId={order?.customer_id}
                    />
                  </React.Fragment>
                ) : (
                  <></>
                )}
                {order?.parent_id && shouldRenderParentButton ? (
                  <Button
                    color="info"
                    onClick={() => {
                      window.open(
                        `/manage-orders/${order?.parent_id}`,
                        "_blank"
                      );
                    }}
                  >
                    {t("button.parent_order")}
                  </Button>
                ) : (
                  <></>
                )}

                {isAllowOrderRefund ? (
                  <>
                    <Button
                      color="info"
                      onClick={() => {
                        toggleOpenRefundOrder(true);
                      }}
                    >
                      {t("detail.order_refund")}
                    </Button>
                    <ConfirmModal
                      isOpen={isOpenRefundOrder}
                      titleHeader={t("detail.order_refund")}
                      titleBody={`${t("form.reason")}`}
                      onConfirm={note => {
                        mutateRefundOrder({
                          orderId: orderId,
                          data: { note: note || "" },
                        });
                      }}
                      textBtnConfirm={t("button.confirm")}
                      textBtnCancel={t("button.cancel")}
                      toggle={toggleOpenRefundOrder}
                      isHaveNote
                      isRequireNote
                      isDisableButton={isLoadingRefundOrder}
                    />
                  </>
                ) : (
                  <></>
                )}
                <WarningNote orderData={order} />
                {conditions.canShowCancelButton ? (
                  <>
                    <Button
                      color="danger"
                      className="border-0"
                      size="xs"
                      onClick={() =>
                        setOpenCancelOrderPopup(!openCancelOrderPopup)
                      }
                    >
                      {t("detail.cancelBtn")}
                    </Button>
                    <ConfirmModal
                      isOpen={openCancelOrderPopup}
                      titleHeader={`${t("action.cancel.title", {
                        order_code: order?.order_code,
                      })} ?`}
                      titleBody={t("action.cancel.description")}
                      onConfirm={handleCancelOrder}
                      textBtnConfirm={t("button.confirm")}
                      textBtnCancel={t("button.cancel")}
                      toggle={() => setOpenCancelOrderPopup(false)}
                      isReasonDeleteCheckbox={true}
                      reasonList={reasonListData?.items}
                      isHaveNote={true}
                    />
                  </>
                ) : (
                  <></>
                )}
              </div>
            </div>
            <Modal
              isOpen={modalRefCodeOpen}
              autoFocus={true}
              toggle={() => setModalRefCodeOpen(!modalRefCodeOpen)}
            >
              <div className="modal-content">
                <ModalHeader>{t("title.update_ref_code")}</ModalHeader>
                <ModalBody>
                  <UpdateRefCodeForm
                    orderId={order?.id}
                    onSuccess={onSuccessInsertOrderRefCode}
                    refCode={orderRefCode}
                  />
                </ModalBody>
              </div>
            </Modal>
            <div className="mt-3 my-md-auto">
              {t("detail.referCode")}:{" "}
              <span>
                {orderRefCode ? (
                  <span>
                    {orderRefCode}
                    <Button
                      className="bg-light"
                      color=""
                      onClick={e => navigator.clipboard.writeText(orderRefCode)}
                    >
                      <i className="far fa-copy fa-md text-secondary" />
                    </Button>
                  </span>
                ) : (
                  <a
                    className="text-danger"
                    onClick={() => setModalRefCodeOpen(true)}
                  >
                    {t("form.no_information")}
                  </a>
                )}
              </span>
            </div>
          </div>
          {conditions.canShowMobileStatus && (
            <div className="mt-2 fs-6">
              Trạng thái:{" "}
              {getLableOrderStatus(dataOrderStatusList, order?.status)}
            </div>
          )}
          {conditions.canShowOrderNote ? (
            <div className={"mt-2"}>
              <i className="dripicons-information text-success"> </i>
              <i>
                {t("message.note", {
                  order_code: order.order_code,
                })}
              </i>
            </div>
          ) : (
            <></>
          )}
          {conditions.canShowCustomerNote ? (
            <div className={"mt-2"}>
              <i className="dripicons-information text-danger"> </i>
              <i className="text-danger">{t("message.note_create_GSNEW")}</i>
            </div>
          ) : (
            <></>
          )}
          <Card body className="mt-3">
            {conditions.canShowReminderAlert && (
              <Alert color="primary">
                Đơn được tạo tự động.
                <Link
                  className="alert-link mx-2"
                  to={`/manage-orders/${order?.order_source_id}`}
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  Xem đơn gốc
                </Link>
              </Alert>
            )}
            <OrderDetailForm
              data={order}
              orderStatusList={dataOrderStatusList}
              provinces={dataProvinces}
              districts={dataDistricts}
              wards={dataWards}
              shippingUnitType={dataShippingTypeAll}
              runner={dataRunner}
              isHCMOrder={isHCMOrder}
              shipping={shipping}
              customer={dataCustomer}
            />
          </Card>
          {shouldRenderChildrenOrders && (
            <OrderDetailChild
              ref={ref}
              path={"manage-orders"}
              parent_id={order?.id}
              parent_code={order?.order_code}
              orderStatusList={dataOrderStatusList}
              receive_bus_info={order?.receive_bus_info}
              receive_bus_notes={order?.receive_bus_notes}
              refetchDetailOrder={refetchDetailOrder}
              isReceiveBus={order?.is_receive_bus}
              parentStatus={order?.status}
            />
          )}
          <OrderDetailAttachments
            data={dataAttachments}
            resourceType={dataResourceType}
            userType={userType}
            resourceData={dataResourceData}
            isLoading={isAttachmentsLoading}
            isLoadingResource={isLoadingResource}
            isDownloadingMultipleResources={isDownloadingMultipleResources}
            isDeletingResource={isDeletingResource}
            getImagePreview={getImagePreview}
            downloadMultipleResources={downloadMultipleResources}
            deleteResource={id => {
              mutateDeleteResource(id);
            }}
          />
          <OrderDetailHistory
            data={dataHistory}
            status={dataOrderStatusList}
            isLoading={isHistoryLoading}
          />
          {dataOrderReminders &&
            dataOrderReminders.items &&
            dataOrderReminders.items.length > 0 && (
              <OrderDetailReminder
                data={dataOrderReminders?.items}
                isLoading={isOrderReminderLoading}
                isDeletingReminder={isDeletingReminder}
                deleteOrderRemind={id => {
                  setIdDeleteRemind(id);
                  toggleDeleteModal();
                }}
                timeSlots={dataTimeSlots?.items}
              />
            )}
        </Container>
      </div>
    </React.Fragment>
  );
};

export default OrderDetailPage;
